import { render, staticRenderFns } from "./attendanceList.vue?vue&type=template&id=24f4dfda&"
import script from "./attendanceList.vue?vue&type=script&lang=ts&"
export * from "./attendanceList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports